export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const REGISTRATION_START = 'REGISTRATION_START';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE';

export const SET_REGISTRATION_DATA = 'SET_REGISTRATION_DATA';
export const REGISTRATION_PREPARE = 'REGISTRATION_PREPARE';

export const PASSWORD_RESET_START = 'PASSWORD_RESET_START';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
export const PASSWORD_RESET_RESET = 'PASSWORD_RESET_RESET';

export const PASSWORD_UPDATE_START = 'PASSWORD_UPDATE_START';
export const PASSWORD_UPDATE_SUCCESS = 'PASSWORD_UPDATE_SUCCESS';
export const PASSWORD_UPDATE_FAILURE = 'PASSWORD_UPDATE_FAILURE';

export const SET_CHANGE_EMAIL_START = 'SET_CHANGE_EMAIL_START';
export const SET_CHANGE_EMAIL_SUCCESS = 'SET_CHANGE_EMAIL_SUCCESS';
export const SET_CHANGE_EMAIL_FAILURE = 'SET_CHANGE_EMAIL_FAILURE';

export const CHECK_CODE_START = 'CHECK_CODE_START';
export const CHECK_CODE_SUCCESS = 'CHECK_CODE_SUCCESS';
export const CHECK_CODE_FAILURE = 'CHECK_CODE_FAILURE';

export const CREATE_PASSWORD_START = 'CREATE_PASSWORD_START';
export const CREATE_PASSWORD_SUCCESS = 'CREATE_PASSWORD_SUCCESS';
export const CREATE_PASSWORD_FAILURE = 'CREATE_PASSWORD_FAILURE';

export const RESEND_CODE_START = 'RESEND_CODE_START';
export const RESEND_CODE_SUCCESS = 'RESEND_CODE_SUCCESS';
export const RESEND_CODE_FAILURE = 'RESEND_CODE_FAILURE';

export const AUTO_LOGIN_START = 'AUTO_LOGIN_START';
export const AUTO_LOGIN_SUCCESS = 'AUTO_LOGIN_SUCCESS';
export const AUTO_LOGIN_FAILURE = 'AUTO_LOGIN_FAILURE';
